import { cva } from 'class-variance-authority';

export const navItemContentVariants = cva('gap-x-md p-md w-full rounded-sm  flex items-center', {
  variants: {
    active: {
      true: 'ua-drawer-nav-active',
      false: 'ua-side-nav-item-active-false',
    },
  },
});

export const navGroupSubItemVariants = cva('gap-x-md p-md w-full rounded-sm  flex items-center', {
  variants: {
    active: {
      true: '',
      false: 'ua-side-nav-item-active-false',
    },
  },
});

export const navGroupItemContentVariants = cva(
  'gap-x-md p-md w-full rounded-sm  flex items-center',
  {
    variants: {
      active: {
        true: 'ua-drawer-nav-active',
        false: 'ua-side-nav-item-active-false',
      },
    },
  },
);

export const navItemLabelVariants = cva('text-md', {
  variants: {
    active: {
      true: 'ua-side-nav-item-active',
      false: 'ua-side-nav-item-active-false',
    },
  },
});

export const navIconVariants = cva('h-4 w-4', {
  variants: {
    active: {
      true: 'ua-side-nav-item-active',
      false: 'ua-side-nav-item-active-false',
    },
  },
});

export const navGroupChevronVariants = cva('h-3 w-3', {
  variants: {
    active: {
      true: 'ua-side-nav-item-active',
      false: 'ua-side-nav-item-active-false',
    },
  },
});
